import { gql } from '@apollo/client';

export default gql`
  mutation deleteInfant($bookingReference: String!, $passengerId: String!) {
    deleteInfant(bookingReference: $bookingReference, passengerId: $passengerId) {
      reference
    }
  }
`;
